module.exports = __webpack_public_path__ + "img/sloat-evoplay.014f6716.jpg";